import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {saveAs} from 'file-saver';
import {Observable, Subject, Subscription} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatStep} from '@angular/material/stepper';
import {debounceTime, finalize, take, takeUntil} from 'rxjs/operators';
import {MatButton} from '@angular/material/button';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {ProviderDTO} from '../../../models/ProviderDTO';
import {CodingSchemaDTO} from '../../../models/CodingSchemaDTO';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {ReturnMessageDTO} from 'src/app/modules/clm/models/ReturnMessageDTO';
import {CodingSchemaService} from '../../../services/coding-schema.service';
import {ProviderService} from '../../../services/provider.service';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {ErrorDialogComponent} from 'src/app/modules/common/dialogs/error-dialog/error-dialog.component';
import {
  Common,
  createFieldMap,
  deepCopy,
  setPotentialNullDateValueForFormControl,
  sortByPropertyAndDirection,
  stringNullOrEmpty
} from 'src/app/modules/common/util/Util';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {AddressDTO} from '../../../models/AddressDTO';
import {ProviderGroupService} from '../../../services/provider-group.service';
import {ProviderGroupDTO} from '../../../models/ProviderGroupDTO';
import {KeycloakService} from 'keycloak-angular';
import {ContactDTO} from '../../../models/ContactDTO';
import {ProviderContractLinkDTO} from '../../../models/ProviderContractLinkDTO';
import {ProviderContractDTO} from '../../../models/ProviderContractDTO';
import {UtilService} from 'src/app/modules/common/services/util.service';
import {DisplayStrings} from 'src/app/modules/common/constants/DisplayStrings';
import {FileUploadService} from '../../../../common/services/file-upload.service';
import {ProviderSpecialityService} from '../../../services/provider-speciality.service';
import {ProviderSpecialtyDTO} from '../../../models/ProviderSpecialtyDTO';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {TableControl} from 'src/app/modules/common/models/TableControl';
import {PagedFilterDTO} from 'src/app/modules/common/models/PagedFilterDTO';
import {Sort} from '@angular/material/sort';
import {SelectionModel} from '@angular/cdk/collections';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {ProviderSpecialtyLinkDTO} from '../../../models/ProviderSpecialtyLinkDTO';
import {ProviderGroupLinkDTO} from '../../../models/ProviderGroupLinkDTO';
import {addDaysToDate, areDatesEqualIgnoringTime} from 'src/app/modules/common/util/DateUtil';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {UserAuthorisationService} from '../../../../common/services/user-authorisation.service';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';
import {
  AddNotesDialogComponent
} from '../../../../common/components/dialogs/add-notes-dialog/add-notes-dialog.component';
import {AddressFormComponent} from '../../../../common/components/common-steps/address-form/address-form.component';
import {ContactFormComponent} from '../../../../common/components/common-steps/contact-form/contact-form.component';

enum TableColumns {
  Select = 'select',
  ProviderSpecialityId = 'providerSpecialityId',
  ProviderCode = 'providerCode',
  Speciality = 'speciality',
  SubSpecialityCode = 'subSpecialityCode',
  SubSpeciality = 'subSpeciality'
}

const PAGE_SIZE = 20;

@Component({
  selector: 'app-submit-claim-view',
  templateUrl: './add-provider-view.component.html',
  styleUrls: [
    './add-provider-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class AddProviderViewComponent implements OnInit, AfterViewChecked, OnDestroy {
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly debounceTimeForSearch = Common.SHORT_DEBOUNCE_TIME;
  readonly tableColumns = TableColumns;
  readonly lookupValue = LookupValue;

  providerSpecialityDisplayedColumns: TableColumns[] = Object.values<TableColumns>(TableColumns);

  previousFilterValue: string = null;
  listFormRowHeight = '60px';
  nameFormControl: FormControl;
  startDateFormControl: FormControl;
  endDateFormControl: FormControl;
  startDateGroupFormControl: FormControl;
  endDateGroupFormControl: FormControl;
  businessTypeFormControl: FormControl;
  providerFacilityTypeFormControl: FormControl;
  regulatorFormControl: FormControl;
  processingClassFormControl: FormControl;
  businessLicenseScannedCopy = null;
  providerNameFormControl: FormControl;
  providerOrderFormControl: FormControl;
  practiceNumberFormControl: FormControl;
  designationFormControl: FormControl;
  titleFormControl: FormControl;
  firstNameFormControl: FormControl;
  middleNameFormControl: FormControl;
  lastNameFormControl: FormControl;
  emailFormControl: FormControl;
  mobileFormControl: FormControl;
  landlineFormControl: FormControl;
  doNotOverwriteContact: FormControl;
  generalFormGroup: FormGroup;
  statutoryFormGroup: FormGroup;
  contractFormGroup: FormGroup;
  businessLicenseNumberFormControl: FormControl;
  vatApplicable = 'No';
  partOfGroup = 'No';
  useGroupPriceList = 'No';
  payGroup = 'No';
  vatNumberFormControl: FormControl;
  licenseCopyFormControl: FormControl;
  gstApplicable = 'No';
  sanctionCheckReferenceNumber: FormControl;
  gstNumber: FormControl;
  contractNameFormControl: FormControl;
  startDateContractFormControl: FormControl;
  endDateContractFormControl: FormControl;
  digitalCopyFormControl: FormControl;
  administratorFormControl: FormControl;
  businessLicenseExpiryFormControl: FormControl;
  entityStatusFormControl: FormControl;
  providerGroupFormControl: FormControl;
  codingSchemaFormControl: FormControl;
  proprietaryCodeFormControl: FormControl;
  daysFormControl: FormControl;
  proprietaryDescriptionFormControl: FormControl;
  percentageFormControl: FormControl;
  settlementStartDateFormControl: FormControl;
  grossAmountFormControl: FormControl;
  settlementEndDateFormControl: FormControl;
  discountAmountFormControl: FormControl;
  currencyFormControl: FormControl;

  selectionControl = new SelectionModel<ProviderSpecialtyDTO>(true, []);
  providerSpecialityTableControl: TableControl;
  providerCodeSearchValue: string;

  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  selectedProvider: ProviderDTO;
  selectedReportingClasses: NameValueDTO;
  selectedContracts: ProviderContractLinkDTO[];
  address: AddressDTO;
  contact: ContactDTO;
  contract: ProviderContractDTO;
  providerId = null;
  providerNetworkList: string;
  providerGroupTextChanged = new Subject<string>();
  codingSchemaTextChanged = new Subject<string>();
  providerGroupSubscription: Subscription;
  codingSchemaTSubscription: Subscription;
  selectedProviderGroup: ProviderGroupDTO;
  filteredCodingSchemas: CodingSchemaDTO[];
  selectedCodingSchemas: CodingSchemaDTO[];
  codingSchemaDescriptionTextChanged = new Subject<string>();
  codingSchemaDescriptionSubscription: Subscription;
  addressErrorMessage: string = null;
  businessType = [];
  facilityTypes = [];
  processingClasses = [];
  regulator = [];
  note: NameValueDTO;
  entityStatus = [];
  addressTypes = [];
  countries = [];
  designations = [];
  titles = [];
  administrators = [];
  currencies = [];
  selectedAddress = null;
  selectedContract = null;
  codingSchema = null;
  helpInfo: HelpDTO[];
  addressErrorMessagesList;
  contactErrorMessages;
  providerGroupDataSource: ProviderGroupDTO[];
  providerSpecialityDataSource: ProviderSpecialtyDTO[];
  heading: string;
  backPageName: string;
  addressRequiredFieldsSelected = true;
  contractsRequiredFieldsSelected = true;
  showSelectSpecialities = false;
  isProvider: boolean;
  userFirstLastName = null;
  returnMessage: ReturnMessageDTO;
  tabName: string;
  isEditMode: boolean;
  isDiscountAmountError: boolean;
  scanCopyFileUploadConfig: any;
  shouldShowProviderNetworkList = false;
  providerGroupHistory: ProviderGroupLinkDTO[] = [];
  initialProviderGroup: ProviderGroupLinkDTO;
  latestFullProviderSpecialitiesList = [];
  addNoteFormControl: FormControl = new FormControl(null);

  readonly filterDataValueTextChanged$ = new Subject<boolean>();
  readonly destroyed$ = new Subject();
  @ViewChild('addressFormComponent') addressFormComponent: AddressFormComponent;
  @ViewChild('generalStep', {static: false}) private generalStep: MatStep;
  @ViewChild('addressStep', {static: false}) private addressStep: MatStep;
  @ViewChild('contactsStep', {static: false}) private contactsStep: MatStep;
  @ViewChild('statutoryStep', {static: false}) private statutoryStep: MatStep;
  @ViewChild('contractStep', {static: false}) private contractStep: MatStep;
  @ViewChild('specialitiesStep', {static: false}) private specialitiesStep: MatStep;
  @ViewChild('contractBackButton', {static: false}) private contractBackButton: MatButton;
  @ViewChild('contractClearButton', {static: false}) private contractClearButton: MatButton;
  @ViewChild('finishButton', {static: false}) private finishButton: MatButton;
  @ViewChild('providerSpecialityPaginator', {static: false}) private providerSpecialitiesPaginator: MatPaginator;
  @ViewChild('toggleSelectedSpecialities', {static: false}) private selectedSpecialitiesToggle: MatSlideToggle;
  @ViewChild('contactFormComponent') contactFormComponent: ContactFormComponent;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private fileUploadService: FileUploadService,
    private snackBar: MatSnackBar,
    private helpService: HelpService,
    private router: Router,
    private providerService: ProviderService,
    private codingSchemaService: CodingSchemaService,
    private lookupService: LookupService,
    private providerGroupService: ProviderGroupService,
    private keycloakService: KeycloakService,
    private utilService: UtilService,
    private providerSpecialityService: ProviderSpecialityService,
    private userAuthorisationService: UserAuthorisationService
  ) {
    this.route.params.subscribe(params => {
      this.providerId = params.id;
    });
    this.backPageName = 'enterprise-management';
    this.selectedCodingSchemas = [];
    this.addressErrorMessagesList = DisplayStrings.addressErrorMessagesList;
    this.contactErrorMessages = DisplayStrings.contactErrorMessages;
    this.addressErrorMessage = this.addressErrorMessagesList.minAddressError;
    this.selectedContracts = [];
    this.gstApplicable = 'No';
    this.vatApplicable = 'No';
    this.nameFormControl = new FormControl('');
    this.startDateFormControl = new FormControl('', [Validators.required]);
    this.endDateFormControl = new FormControl();
    this.startDateGroupFormControl = new FormControl(''); // TODO: toggle validity when Part of Group is toggled
    this.endDateGroupFormControl = new FormControl('');
    this.businessTypeFormControl = new FormControl('');
    // TODO: only required when editing provider
    this.providerFacilityTypeFormControl = new FormControl('');
    this.processingClassFormControl = new FormControl('', [Validators.required]);
    this.regulatorFormControl = new FormControl('', [Validators.required]);
    this.providerNameFormControl = new FormControl('', [Validators.required]);
    this.providerOrderFormControl = new FormControl();
    this.practiceNumberFormControl = new FormControl('', [Validators.required]);
    this.designationFormControl = new FormControl();
    this.titleFormControl = new FormControl();
    this.firstNameFormControl = new FormControl();
    this.middleNameFormControl = new FormControl();
    this.lastNameFormControl = new FormControl();
    this.emailFormControl = new FormControl();
    this.mobileFormControl = new FormControl();
    this.landlineFormControl = new FormControl();
    this.doNotOverwriteContact = new FormControl();
    this.businessLicenseNumberFormControl = new FormControl('');
    this.vatNumberFormControl = new FormControl();
    this.licenseCopyFormControl = new FormControl();
    this.businessLicenseExpiryFormControl = new FormControl('', [Validators.required]);
    this.sanctionCheckReferenceNumber = new FormControl();
    this.gstNumber = new FormControl();
    this.contractNameFormControl = new FormControl();
    this.startDateContractFormControl = new FormControl();
    this.endDateContractFormControl = new FormControl();
    this.digitalCopyFormControl = new FormControl();
    this.administratorFormControl = new FormControl();
    this.entityStatusFormControl = new FormControl('', [Validators.required]);
    this.providerGroupFormControl = new FormControl();
    this.codingSchemaFormControl = new FormControl();
    this.proprietaryCodeFormControl = new FormControl();
    this.daysFormControl = new FormControl();
    this.proprietaryDescriptionFormControl = new FormControl();
    this.percentageFormControl = new FormControl();
    this.settlementStartDateFormControl = new FormControl();
    this.grossAmountFormControl = new FormControl();
    this.settlementEndDateFormControl = new FormControl();
    this.discountAmountFormControl = new FormControl();
    this.currencyFormControl = new FormControl();
    this.businessLicenseNumberFormControl = new FormControl('');
    this.isDiscountAmountError = false;

    this.scanCopyFileUploadConfig = {
      uploadedFileData: null,
      clearFileData: true
    };

    // FormGroups:
    this.generalFormGroup = this.formBuilder.group({
      name: this.providerNameFormControl,
      practiceNumber: this.practiceNumberFormControl,
      entityStatus: this.entityStatusFormControl,
      businessType: this.businessTypeFormControl,
      providerFacilityType: this.providerFacilityTypeFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl,
      regulator: this.regulatorFormControl,
      processingClass: this.processingClassFormControl,
      startDateGroup: this.startDateGroupFormControl,
      endDateGroup: this.endDateGroupFormControl,
    });
    this.contractFormGroup = this.formBuilder.group({
      name: this.contractNameFormControl,
      startDate: this.startDateContractFormControl,
      endDate: this.endDateContractFormControl,
      digitalCopy: this.digitalCopyFormControl,
      administrator: this.administratorFormControl
    });
    this.statutoryFormGroup = this.formBuilder.group({
        businessLicenseExpiryDate: this.businessLicenseExpiryFormControl,
        businessLicenseNumber: this.businessLicenseNumberFormControl,
        vatNumber: this.vatNumberFormControl,
        licenseCopy: this.licenseCopyFormControl,
        sanctionCheckReferenceNumber: this.sanctionCheckReferenceNumber,
        gstNumber: this.gstNumber
      }
    );

    this.initializeTableControls();
    this.initializeSubscriptions();

  }

  get bannerText(): string {
    let bannerText = '';
    if (!this.isAllowedToSubmit()) {
      bannerText = DisplayStrings.permissionsErrorMessages.rolePermissions.roleEnterpriseManager;
    }
    return bannerText;
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
    if (this.route.snapshot.url[1].path === 'add-provider-group') {
      this.isProvider = false;
      this.isEditMode = false;
      this.getHelpInfo('Provider Group');
      this.heading = 'Add Provider Group';
      this.tabName = 'provider-group';
    }
    else if (this.route.snapshot.url[1].path === 'add-provider') {
      this.isProvider = true;
      this.isEditMode = false;
      this.getHelpInfo('Provider');
      this.getListOfProviderSpecialities(true);
      this.heading = 'Add Provider';
      this.tabName = 'provider';
    }
    if (this.providerId && this.route.snapshot.url[1].path === 'edit-provider-group') {
      this.isProvider = false;
      this.isEditMode = true;
      this.getProviderGroupById(this.providerId);
      this.getHelpInfo('Provider Group');
      this.heading = 'Edit Provider Group';
      this.tabName = 'provider-group';
    }
    else if (this.providerId && this.route.snapshot.url[1].path === 'edit-provider') {
      this.isProvider = true;
      this.isEditMode = true;
      this.shouldShowProviderNetworkList = true;
      this.getProviderById(this.providerId);
      this.getHelpInfo('Provider');
      this.heading = 'Edit Provider';
      this.tabName = 'provider';
    }
    this.getListOfLookupValues(this.lookupValue.BusinessType);
    this.getListOfLookupValues(this.lookupValue.Regulator);
    this.getListOfLookupValues(this.lookupValue.EntityStatus);
    this.getListOfLookupValues(this.lookupValue.AddressType);
    this.getListOfLookupValues(this.lookupValue.Country);
    this.getListOfLookupValues(this.lookupValue.DesignationProvider);
    this.getListOfLookupValues(this.lookupValue.Administrator);
    this.getListOfLookupValues(this.lookupValue.Title);
    this.getListOfLookupValues(this.lookupValue.Currency);
    this.getListOfLookupValues(this.lookupValue.PriceListType);
    this.getListOfLookupValues(this.lookupValue.FacilityType);
    this.getListOfLookupValues(this.lookupValue.ProcessingClass);
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  ngOnDestroy(): void {
    this.codingSchemaDescriptionSubscription.unsubscribe();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  /*
  * SERVICE CALLS
  */

  initializeSubscriptions() {
    this.filterDataValueTextChanged$
      .pipe(
        takeUntil(this.destroyed$),
        debounceTime(this.debounceTimeForSearch)
      )
      .subscribe(() => this.getListOfProviderSpecialities());

    this.providerGroupSubscription = this.providerGroupTextChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.getFilteredListOfProviderGroups();
      });

    this.codingSchemaTSubscription = this.codingSchemaTextChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.getFilteredListOfCodingSchemas(this.codingSchemaFormControl.value);
      });

    this.codingSchemaDescriptionSubscription = this.codingSchemaDescriptionTextChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe((searchText) => {
        this.getFilteredListOfCodingSchemas(searchText);
      });
  }

  toggleShowSelectedProviderSpecialities() {

    if (this.providerCodeSearchValue) {
      this.previousFilterValue = this.providerCodeSearchValue;
      this.providerCodeSearchValue = null;
      this.setFilterValue(null);
    }

    if (this.selectionControl.selected?.length === 0) {
      this.showSelectSpecialities = false;
      this.selectedSpecialitiesToggle.checked = false;

      if (this.providerSpecialityDataSource.length === this.latestFullProviderSpecialitiesList.length) {
        this.snackBar.open(`Please select at least 1 provider speciality`, 'Dismiss');
      }
      this.providerSpecialitiesPaginator.firstPage();
    }
    else {
      const shouldShowSelectedSpecialities = this.showSelectSpecialities && this.selectionControl.selected.length !== 0;
      this.latestFullProviderSpecialitiesList = shouldShowSelectedSpecialities ? this.providerSpecialityDataSource : this.latestFullProviderSpecialitiesList;
      this.providerSpecialityDataSource = shouldShowSelectedSpecialities ? this.selectionControl.selected : this.latestFullProviderSpecialitiesList;
      this.providerCodeSearchValue = shouldShowSelectedSpecialities ? this.providerCodeSearchValue : this.previousFilterValue;
    }
  }

  onCheckboxChange(event: MatCheckboxChange, providerSpecialityDTO: ProviderSpecialtyDTO) {
    if (!event.checked) {
      const deselectedItem: ProviderSpecialtyDTO = this.selectionControl.selected.find(s => s.providerSpecialityId === providerSpecialityDTO.providerSpecialityId);
      this.selectionControl.deselect(deselectedItem);
    }
    else {
      this.selectionControl.toggle(providerSpecialityDTO);
    }
  }

  isSelected(providerSpecialityDTO: ProviderSpecialtyDTO): ProviderSpecialtyDTO {
    return this.selectionControl.selected.find(s => s.providerSpecialityId === providerSpecialityDTO.providerSpecialityId);
  }

  clearSelection(): void {
    this.selectionControl.clear();
  }

  providerIsMedical(): boolean {
    return this.processingClassFormControl.value === 'Medical';
  }

  pageChanged($event: PageEvent): void {
    this.providerSpecialityTableControl.pageNumber = $event.pageIndex;
    this.providerSpecialityTableControl.pageSize = $event.pageSize;
    this.getListOfProviderSpecialities();
  }

  onInputChangedFilterSpecialityData(event: Event): void {
    this.showSelectSpecialities = false;
    this.setFilterValue((event.target as HTMLInputElement).value);
    this.filterDataValueTextChanged$.next(true);
  }

  setFilterValue(filterValue: string): void {
    this.providerSpecialitiesPaginator.firstPage();
    this.providerSpecialityTableControl.pageNumber = 0;
    this.providerSpecialityTableControl.filterValue = filterValue;
  }

  sortData($event: Sort): void {
    if (!this.selectedSpecialitiesToggle.checked) {
      this.providerSpecialityTableControl.pageNumber = 0;
      this.providerSpecialityTableControl.sortField = $event.active;
      this.providerSpecialityTableControl.sortDirection = $event.direction;
      this.getListOfProviderSpecialities();
    }
    else {
      const sortedProviderSpecialityDataSource: ProviderSpecialtyDTO[] = this.providerSpecialityDataSource.sort(sortByPropertyAndDirection($event.active, $event.direction));
      this.providerSpecialityDataSource = [];
      sortedProviderSpecialityDataSource.forEach((speciality: ProviderSpecialtyDTO) => this.providerSpecialityDataSource.push(speciality));
    }
  }

  initializeTableControls(): void {
    this.providerSpecialityTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      this.tableColumns.ProviderSpecialityId,
      'asc',
      this.tableColumns.ProviderCode,
      ''
    );
  }

  buildProviderSpecialityPagedRequestDTO(tableControl: TableControl): PagedRequestDTO {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblProviderSpeciality;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = tableControl.sortDirection == 'asc' ? 'ASCENDING' : 'DESCENDING';

    const namePagedFilterDTO = new PagedFilterDTO();
    namePagedFilterDTO.name = this.tableColumns.ProviderCode;
    namePagedFilterDTO.value = tableControl.filterValue;
    namePagedFilterDTO.operator = null;

    pagedRequestDTO.fieldMap = {};
    pagedRequestDTO.fieldMap[this.tableColumns.ProviderCode] = namePagedFilterDTO;

    return pagedRequestDTO;
  }

  getListOfProviderSpecialities(firstLoad?: boolean): void {
    this.providerSpecialityService.getListOfProviderSpecialities(this.buildProviderSpecialityPagedRequestDTO(this.providerSpecialityTableControl))
      .subscribe(response => {
        this.providerSpecialityDataSource = response.resultList;
        this.providerSpecialityTableControl.length = response.totalRecords;
        if (firstLoad) {
          this.latestFullProviderSpecialitiesList = response.resultList;
          this.setSelectedProviderSpecialities();
        }
      });
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  getProviderGroupById(providerGroupId: number): void {
    this.providerGroupService.getProviderGroup(providerGroupId)
      .pipe(take(1))
      .subscribe({
        next: (response: ProviderGroupDTO) => {
          this.selectedProviderGroup = response;
          if (!this.isProvider) {
            this.setFormsForEdit(response);
          }
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.handleError(error.businessMessage);
        }
      });
  }

  getProviderById(providerGroupId: number): void {
    this.providerService.getProvider(providerGroupId)
      .pipe(take(1))
      .subscribe(
        (response: ProviderDTO) => {
          this.selectedProvider = response;
          this.setFormsForEdit(response);
          this.getListOfProviderSpecialities(true);
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.handleError(error.businessMessage);
        }
      );
  }

  setSelectedProviderSpecialities() {
    this.selectedProvider?.providerSpecialties?.forEach(speciality => this.selectionControl.select(speciality.providerSpecialtyDTO));
    if (this.selectionControl.selected.length > 0) {
      this.showSelectSpecialities = true;
      this.toggleShowSelectedProviderSpecialities();
    }
  }

  setFormsForEdit(data) {
    const entityStatus = data.entityStatus?.name;
    const businessType = data.businessType?.name;
    const providerFacilityType = data.providerFacilityType?.name;
    const processingClass = data.processingClass?.name;
    const regulator = data.regulator?.name;
    this.providerNetworkList = stringNullOrEmpty(data.providerNetworkList) ? 'None' : data.providerNetworkList;
    this.providerNameFormControl.setValue(data.name);
    this.entityStatusFormControl.setValue(entityStatus);
    this.practiceNumberFormControl.setValue(data.practiceNumber);
    this.businessTypeFormControl.setValue(businessType);
    this.startDateFormControl.setValue(new Date(data.startDate));
    this.providerFacilityTypeFormControl.setValue(providerFacilityType);
    this.regulatorFormControl.setValue(regulator);
    this.endDateFormControl.setValue(setPotentialNullDateValueForFormControl(data.endDate));
    this.selectedReportingClasses = data.reportingClass;
    this.processingClassFormControl.setValue(processingClass);
    this.setFormValidatorsByProcessingClass(processingClass);
    if (this.isProvider && data.providerGroups && data.providerGroups.length > 0) {
      this.providerGroupHistory = data.providerGroups;
      // sort by start date descending
      this.providerGroupHistory.sort((a, b) => {
        return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
      });
      this.initialProviderGroup = this.providerGroupHistory[0];

      this.partOfGroup = 'Yes';
      if (this.initialProviderGroup.endDate) {
        const today = new Date();
        if (areDatesEqualIgnoringTime(today, new Date(this.initialProviderGroup.endDate)) || this.initialProviderGroup.endDate < today) {
          this.partOfGroup = 'No';
        }
      }
      if (this.isProvider) {
        this.note = data.note;
        this.addNoteFormControl.patchValue(data.note?.name);
      }
      this.payGroup = this.initialProviderGroup.payToGroup && this.initialProviderGroup.payToGroup ? 'Yes' : 'No';
      this.useGroupPriceList = this.initialProviderGroup.useGroupPriceList && this.initialProviderGroup.useGroupPriceList ? 'Yes' : 'No';
      this.providerGroupFormControl.setValue(this.initialProviderGroup.providerGroupDTO.name);
      this.startDateGroupFormControl.setValue(setPotentialNullDateValueForFormControl(this.initialProviderGroup.startDate));
      this.endDateGroupFormControl.setValue(setPotentialNullDateValueForFormControl(this.initialProviderGroup.endDate));
      this.getProviderGroupById(this.initialProviderGroup.providerGroupDTO.providerGroupId);
    }
    this.startDateChange();
    this.endDateChange();
    this.generalFormGroup = this.formBuilder.group({
      name: this.providerNameFormControl,
      practiceNumber: this.practiceNumberFormControl,
      entityStatus: this.entityStatusFormControl,
      businessType: this.businessTypeFormControl,
      providerFacilityType: this.providerFacilityTypeFormControl,
      startDate: this.startDateFormControl,
      regulator: this.regulatorFormControl,
      endDate: this.endDateFormControl,
      processingClass: this.processingClassFormControl,
      startDateGroup: this.startDateGroupFormControl,
      endDateGroup: this.endDateGroupFormControl
    });
    this.blurProviderOrProviderGroupHeading();
    this.businessLicenseNumberFormControl.setValue(data.businessLicenseNumber);
    this.vatNumberFormControl.setValue(data.vatNumber);
    this.licenseCopyFormControl.setValue(data.businessLicenseScannedCopy);
    this.businessLicenseScannedCopy = data.businessLicenseScannedCopy;
    this.sanctionCheckReferenceNumber.setValue(data.sanctionReference);
    this.gstNumber.setValue(data.gstNumber);
    this.businessLicenseExpiryFormControl.setValue(new Date(data.businessLicenseExpiryDate));
    this.gstApplicable = data.gstOverride ? 'Yes' : 'No';
    this.vatApplicable = data.vatOverride ? 'Yes' : 'No';
    this.statutoryFormGroup = this.formBuilder.group({
        businessLicenseExpiryDate: this.businessLicenseExpiryFormControl,
        businessLicenseNumber: this.businessLicenseNumberFormControl,
        vatNumber: this.vatNumberFormControl,
        licenseCopy: this.licenseCopyFormControl,
        sanctionCheckReferenceNumber: this.sanctionCheckReferenceNumber,
        gstNumber: this.gstNumber
      }
    );
    if (data.contracts?.length) {
      this.selectedContracts = data.contracts.map(element => {
        element.updated = new Date();
        element.updatedBy = this.userFirstLastName;
        element.created = new Date();
        element.createdBy = this.userFirstLastName;
        element.contract.updated = new Date();
        element.contract.updatedBy = this.userFirstLastName;
        element.contract.created = new Date();
        element.contract.createdBy = this.userFirstLastName;
        return element;
      });
    }

    this.contractFormGroup = this.formBuilder.group({
      name: this.contractNameFormControl,
      startDate: this.startDateContractFormControl,
      endDate: this.endDateContractFormControl,
      digitalCopy: this.digitalCopyFormControl,
      administrator: this.administratorFormControl
    });

  }

  handleInputChangeForLicenseCopy(e) {

    const fileList: FileList = e.target.files;

    const file: File = fileList[0];
    if (file.size > 5000000) {
      return;
    }
    this.getBase64ForLicenseCopy(e);
    this.licenseCopyFormControl.setValue(file.name);
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.BusinessType) {
          this.businessType = response;
        }
        else if (entity === this.lookupValue.Regulator) {
          this.regulator = response;
        }
        else if (entity === this.lookupValue.AddressType) {
          this.addressTypes = response;
        }
        else if (entity === this.lookupValue.EntityStatus) {
          this.entityStatus = response.filter(x => x.value != 0);
        }
        else if (entity === this.lookupValue.Country) {
          this.countries = response;
        }
        else if (entity === this.lookupValue.DesignationProvider) {
          this.designations = response;
        }
        else if (entity === this.lookupValue.Title) {
          this.titles = response;
        }
        else if (entity === this.lookupValue.Administrator) {
          this.administrators = response;
        }
        else if (entity === this.lookupValue.Currency) {
          this.currencies = response;
        }
        else if (entity === this.lookupValue.FacilityType) {
          this.facilityTypes = response;
        }
        else if (entity === this.lookupValue.ProcessingClass) {
          this.processingClasses = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo ? helpInfo.inputInfo : '';
    }
    return message;
  }

  startDateChange(): void {
    this.startDateContractFormControl.setValue(this.startDateFormControl.value);
  }

  endDateChange(): void {
    this.endDateContractFormControl.setValue(this.endDateFormControl.value);
  }

  startDateChangeOnProviderGroup(): void {
    const newEndDate = addDaysToDate(this.startDateGroupFormControl.value, -1);
    if (this.hasProviderGroupBeenUpdated()) {
      this.initialProviderGroup.endDate = newEndDate;
    }
    else if (this.providerGroupHistory.length > 1) {
      this.providerGroupHistory[1].endDate = newEndDate;
    }
  }

  endDateChangeOnProviderGroup(): void {
    this.endDateChange();
    if (this.initialProviderGroup) {
      this.initialProviderGroup.endDate = !this.hasProviderGroupBeenUpdated() ? this.endDateGroupFormControl.value : this.initialProviderGroup.endDate;
    }
  }

  hasProviderGroupBeenUpdated(): boolean {
    const intialProviderGroupId = this.initialProviderGroup?.providerGroupDTO?.providerGroupId;
    return this.initialProviderGroup && intialProviderGroupId !== this.selectedProviderGroup?.providerGroupId;
  }

  getFilteredListOfProviderGroups(): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblProviderGroup;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;

    pagedRequestDTO.fieldMap = createFieldMap(
      'name',
      this.providerGroupFormControl.value
    );
    this.providerGroupService.getListOfProviderGroups(pagedRequestDTO).subscribe(
      (response) => {
        this.providerGroupDataSource = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      },
    );
  }

  getAddressDisplayString(address) {
    return `${address?.type?.name} - ${address?.addressLineOne} - ${address?.cityTown} - ${address?.province} -
    ${address?.country?.name} - ${address?.postalCode}`;
  }

  getContactDisplayString(contact) {
    return `${contact?.designation?.name} - ${contact?.title?.name} ${contact?.firstName} ${contact?.middleName ? contact.middleName : ''} ${contact?.lastName} -
    ${contact?.emailAddress} - Mobile: ${contact?.mobileNumber} - Landline: ${contact?.telephoneNumber}`;
  }

  getContractDisplayString(contract) {
    return `${contract?.contract?.name} -  ${this.utilService.dateFormat(contract?.startDate)}  ${contract?.endDate ? this.utilService.dateFormat(contract?.endDate) : ''} - ${contract.contract?.administrator.name}`;
  }

  onDiscountAmountValue() {
    const discountValue = Number(this.discountAmountFormControl.value);
    this.discountAmountFormControl.setValue(discountValue.toFixed(2));
  }

  onGrossAmountValue() {
    const grossValue = Number(this.grossAmountFormControl.value);
    this.grossAmountFormControl.setValue(grossValue.toFixed(2));
  }

  getFilteredListOfCodingSchemas(searchText: string): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblCodingSchema;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;


    pagedRequestDTO.fieldMap = createFieldMap(
      'shortDescription',
      searchText
    );

    this.codingSchemaService.getListOfCodingSchemas(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredCodingSchemas = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      },
    );
  }

  /*
  * PAGE METHODS
  */

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000
    });
  }

  handleError(errorMessage: string) {
    this.dialog.open(ErrorDialogComponent, {
      width: '40vw',
      data: errorMessage
    });
  }

  submitProvider() {
    if (!this.isAllowedToSubmit()) {
      return;
    }
    this.returnMessage = null;
    // providerId when user add a new provider or provider Group
    this.disableActivityPage();

    if (this.providerId === null) {
      const provider = this.getProviderDTOPayload();
      // when user a new provider
      if (this.isProvider) {
        this.providerService.addProvider(provider)
          .pipe(
            finalize(() => this.enableActivityPage()),
            takeUntil(this.destroyed$)
          )
          .subscribe({
            next: (response) => {
              this.returnMessage = response;
              this.openSnackBar(
                `Provider ${response.name} saved successfully`,
                'Dismiss'
              );
              this.router.navigate(['/enterprise-management'], {queryParams: {tab: 'provider'}});
            },
            error: (errorResponse) => {
              const error = errorResponse.error;
              this.handleError(error.businessMessage);
            }
          });
      }
      // user add a new provider group
      else {
        const providerGroup = this.getProviderGroupDTOPayload();
        this.providerGroupService.addProviderGroup(providerGroup)
          .pipe(
            finalize(() => this.enableActivityPage()),
            takeUntil(this.destroyed$)
          )
          .subscribe({
            next: (response) => {
              this.returnMessage = response;
              this.openSnackBar(
                `Provider Group ${response.name} saved successfully`,
                'Dismiss'
              );
              this.router.navigate(['/enterprise-management'], {queryParams: {tab: 'provider-group'}});
            },
            error: (errorResponse) => {
              const error = errorResponse.error;
              this.handleError(error.businessMessage);
            }
          });
      }
    }
    else {
      // when user a edit provider
      if (this.isProvider) {
        const provider = this.getProviderDTOPayload();
        this.providerService.addProvider(provider).subscribe(
          response => {
            this.returnMessage = response;
            this.openSnackBar(
              `Provider ${response.name} updated successfully`,
              'Dismiss'
            );
            this.router.navigate(['/enterprise-management'], {queryParams: {tab: 'provider'}});
          },
          errorResponse => {
            const error = errorResponse.error;
            this.handleError(error.businessMessage);
            this.enableActivityPage();
          },
          () => {
            this.enableActivityPage();
          }
        );
      }
      // user add a eit provider group
      else {
        const providerGroup = this.getProviderGroupDTOPayload();
        this.providerGroupService.addProviderGroup(providerGroup).subscribe(
          response => {
            this.returnMessage = response;
            this.openSnackBar(
              `Provider Group ${response.name} updated successfully`,
              'Dismiss'
            );
            this.router.navigate(['/enterprise-management'], {queryParams: {tab: 'provider-group'}});
          },
          errorResponse => {
            const error = errorResponse.error;
            this.handleError(error.businessMessage);
            this.enableActivityPage();
          },
          () => {
            this.enableActivityPage();
          }
        );
      }
    }
  }

  getReturnMessage(): string {
    return this.returnMessage == null ? '' : this.returnMessage.message;
  }

  displayReturnMessage(): boolean {
    return this.returnMessage != null;
  }

  onInputChangedSearchProviderGroup($event) {
    this.providerGroupTextChanged.next($event.target.value);
  }

  searchCodingSchema($event) {
    this.codingSchemaTextChanged.next($event.target.value);
  }

  providerGroupSelected(providerGroup: ProviderGroupDTO): void {
    this.providerGroupFormControl.setValue(providerGroup.name);
    this.getProviderGroupById(providerGroup.providerGroupId);
    this.updateDatesForPreviousAndNextProviderGroup();
  }

  updateDatesForPreviousAndNextProviderGroup(): void {
    // the start date of the new provider group needs to be set when no end date has been provided for the prior provider group
    if (this.endDateGroupFormControl.value) {
      this.startDateGroupFormControl.setValue(addDaysToDate(this.endDateGroupFormControl.value, 1));
    }
    else {
      const today = new Date();
      const initialStartDate = new Date(this.initialProviderGroup?.startDate);
      const newStartDate = this.initialProviderGroup && today < initialStartDate || areDatesEqualIgnoringTime(today, initialStartDate) ?
        addDaysToDate(initialStartDate, 1) : today;
      this.startDateGroupFormControl.setValue(new Date(newStartDate));

      if (this.initialProviderGroup) {
        this.initialProviderGroup.endDate = addDaysToDate(newStartDate, -1);
      }
    }
    this.endDateGroupFormControl.setValue(null);
  }

  codingSchemaAutoSelected(codingSchema) {
    this.codingSchema = codingSchema;
    this.codingSchemaFormControl.setValue(`${codingSchema.code} - ${codingSchema.shortDescription}`);
  }

  onClickOpenAddNoteDialog($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

    const dialogRef: MatDialogRef<AddNotesDialogComponent> = this.dialog.open(AddNotesDialogComponent, {
      width: '40vw',
      data: {
        note: this.addNoteFormControl.value,
      }
    });

    dialogRef
      .afterClosed()
      .subscribe((note: string): void => {
        this.addNoteFormControl.patchValue(note);
      });
  }

  getBase64ForLicenseCopy(event) {
    const me = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    reader.onload = () => {
      me.businessLicenseScannedCopy = reader.result;

    };
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  }


  addContract() {
    if (
      this.contractNameFormControl.value != null &&
      this.startDateContractFormControl.value != null &&
      this.administratorFormControl.value != null
    ) {
      this.contract = {
        name: this.contractNameFormControl.value,
        providerContractId: null,
        scanCopyFile: this.getScanCopyFileFileDTOPayload(),
        administrator: this.administratorFormControl.value,
        created: new Date(),
        createdBy: this.userFirstLastName,
        tenantId: null,
        updated: null,
        updatedBy: null
      };
      const contractLink: ProviderContractLinkDTO = {
        contract: this.contract,
        endDate: this.endDateContractFormControl.value !== null && this.endDateContractFormControl.value !== ''
          ? new Date(this.endDateContractFormControl.value) : null,
        startDate: new Date(this.startDateContractFormControl.value),
        created: new Date(),
        createdBy: this.userFirstLastName,
        tenantId: null,
        updated: null,
        updatedBy: null
      };

      this.selectedContract = null;
      this.selectedContracts.push(contractLink);
      this.contractFormGroup.reset();
      this.clearScanCopyFileUpload(); // remove file byte[] from original reference
    }
    else {
      this.contractsRequiredFieldsSelected = false;
    }

  }

  editContract(contract) {

    if (this.selectedContract) {
      // Note: Edge case:
      // Click Edit on 1 contract
      // Click Edit on other contract without saving
      // You need to push back the selected contract otherwise filter logic will remove it.

      this.selectedContracts.push(this.selectedContract);
      this.selectedContract = null;
    }
    this.selectedContract = contract;
    const administrator = this.administrators.find(item => item.value === contract.contract.administrator.value);
    this.contractNameFormControl.setValue(contract.contract.name);
    this.startDateContractFormControl
      .setValue(contract.startDate !== null && contract.startDate !== '' ? new Date(contract.startDate) : null);
    this.endDateContractFormControl
      .setValue(contract.endDate !== null
      && contract.endDate > 0 && contract.endDate !== '' ? new Date(contract.endDate) : null);
    this.administratorFormControl.setValue(administrator);

    if (contract.contract.scanCopyFile) {
      this.scanCopyFileUploadConfig.uploadedFileData = contract.contract.scanCopyFile;
    }

    this.selectedContracts = this.selectedContracts.filter(item => JSON.stringify(item.contract) !== JSON.stringify(contract.contract));
    if (this.selectedContracts.length === 0) {
      this.contractFormGroup = this.formBuilder.group({
        name: this.contractNameFormControl,
        startDate: this.startDateContractFormControl,
        endDate: this.endDateContractFormControl,
        digitalCopy: this.digitalCopyFormControl,
        administrator: this.administratorFormControl
      });
    }
  }

  removeContract(contact) {
    const index = this.selectedContracts.indexOf(contact, 0);
    if (index > -1) {
      this.selectedContracts.splice(index, 1);
    }
    if (this.selectedContracts.length === 0) {
      this.contractFormGroup = this.formBuilder.group({
        name: this.contractNameFormControl,
        startDate: this.startDateContractFormControl,
        endDate: this.endDateContractFormControl,
        digitalCopy: this.digitalCopyFormControl,
        administrator: this.administratorFormControl
      });
    }
  }

  blurProviderOrProviderGroupHeading() {
    if (this.route.snapshot.url[1].path === 'add-provider-group') {
      this.heading = `Add Provider Group - ${this.providerNameFormControl.value}`;
    }
    else if (this.route.snapshot.url[1].path === 'add-provider') {
      this.heading = `Add Provider - ${this.providerNameFormControl.value}`;
    }
    if (this.providerId && this.route.snapshot.url[1].path === 'edit-provider-group') {
      this.heading = `Edit Provider Group - ${this.providerNameFormControl.value}`;
    }
    else if (this.providerId && this.route.snapshot.url[1].path === 'edit-provider') {
      this.heading = `Edit Provider - ${this.providerNameFormControl.value}`;
    }
  }

  downloadScanCopyFileUploadFile($event) {
    $event.preventDefault();
    const {name, extension, file} = this.scanCopyFileUploadConfig.uploadedFileData;
    const blobData = this.fileUploadService.base64toBlob(file, 'data:application/octet-stream;base64');
    const blob = new Blob([blobData]);
    saveAs(blob, `${name}${extension}`);
  }

  searchCodingSchemas($event) {
    this.codingSchemaDescriptionTextChanged.next($event.target.value);
  }

  getSelectedCodingSchema(name: string): CodingSchemaDTO {
    if (this.selectedCodingSchemas && name !== '') {
      return this.selectedCodingSchemas.find((item) => name === this.getCodingSchemaDisplayString(item));
    }
    else if (this.filteredCodingSchemas && name !== '') {
      return this.filteredCodingSchemas.find((item) => name === this.getCodingSchemaDisplayString(item));
    }
    else {
      return null;
    }
  }

  codingSchemaSelected(name: string) {
    if (this.filteredCodingSchemas && name !== '') {
      const codingSchema = this.filteredCodingSchemas.find((item) => this.getCodingSchemaDisplayString(item) === name);
      this.selectedCodingSchemas.push(codingSchema);
    }
  }

  clearProviderGroup() {
    this.providerGroupFormControl.reset();
    this.providerGroupDataSource = [];
  }

  resetGeneralFormGroup() {
    this.generalFormGroup.reset();
  }

  resetStatutoryFormGroup() {
    this.statutoryFormGroup.reset();
  }

  resetContractFormGroup() {
    this.contractFormGroup.reset();
  }

  getCodingSchemaDisplayString(codingSchema: CodingSchemaDTO): string {
    return `${codingSchema.code}: ${codingSchema.shortDescription}`;
  }


  onFileUploadSuccess(uploadedFileResponse: any) {
    if (!uploadedFileResponse) {
      return;
    }

    // Add Case:
    // - Attach file -> Change file

    // Edit Case:
    // - Change(Modified) existing file -> delete existing file

    const previousUploadedFile = this.scanCopyFileUploadConfig.uploadedFileData;
    if (previousUploadedFile && previousUploadedFile.file) {
      const {fileId} = previousUploadedFile;

      this.deleteFile$(fileId)
        .pipe(
          finalize(() => {
            this.deleteLocalFileState();
            this.setScanCopyFileUpload(uploadedFileResponse); // Reassign new uploaded file:
          })
        )
        .subscribe(
          () => {
            //  Empty Subscription
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.handleError(error.message);
            console.log(`File with ${fileId} deleted from Angular local state not from server!`);
          }
        );
    }
    else if (uploadedFileResponse.fileId) {
      this.setScanCopyFileUpload(uploadedFileResponse);
    }
  }

  onDeleteFile($event: MouseEvent, fileId: bigint) {
    $event.stopPropagation();
    this.deleteFile$(fileId)
      .pipe(
        finalize(() => {
          this.deleteLocalFileState();
        })
      )
      .subscribe(
        () => {
          //  Empty Subscription
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.handleError(error.message);
          console.log(`File with ${fileId} deleted from Angular local state not from server!`);
        }
      );
  }

  processingClassSelected(name: string) {
    this.setFormValidatorsByProcessingClass(name);
  }

  disableProviderGroupPriceListRadioGroup() {
    let disabled = false;
    if (this.selectedProviderGroup == null) {
      disabled = true;
    }
    return disabled;
  }

  disablePartOfGroupRadioGroup(): boolean {
    return this.selectedProviderGroup && !this.endDateGroupFormControl.value;
  }

  getProviderGroupHistoryToDisplay(): ProviderGroupLinkDTO[] {
    // Provider group history includes current provider group on load.
    // This should only be included in the history summary if a new provider group has been selected
    const shouldShowFullList = this.hasProviderGroupBeenUpdated() || this.partOfGroup === 'No';
    return shouldShowFullList ? this.providerGroupHistory : this.providerGroupHistory.slice(1);
  }

  isAllowedToSubmit(): boolean {
    let hasAccessToSubmitProvider = false;
    const hasRoleOperationsManager = this.userAuthorisationService.hasRoleEnterpriseManager();

    if (hasRoleOperationsManager) {
      hasAccessToSubmitProvider = true;
    }
    return hasAccessToSubmitProvider;
  }

  isFinishButtonDisabled(): boolean {
    let isDisabled = false;

    if (!this.isAllowedToSubmit()) {
      isDisabled = true;
    }
    else if (this.contractFormGroup.invalid) {
      isDisabled = true;
    }
    return isDisabled;
  }

  getFinishButtonTooltip(): string | null {
    if (!this.isAllowedToSubmit()) {
      return this.bannerText;
    }
    return null;
  }

  getClearButtonTooltip(): string | null {
    if (!this.isAllowedToSubmit()) {
      return DisplayStrings.permissionsErrorMessages.rolePermissions.rolEnterpriseManagerClearData;
    }
    return null;
  }

  private getScanCopyFileFileDTOPayload() {
    const config = deepCopy(this.scanCopyFileUploadConfig);
    if (config && config.uploadedFileData) {
      let updatedFile = config.uploadedFileData;

      // Metadata info emitted from `FileUploadComponent` as BE does accept FileDTO
      delete config.uploadedFileData.date;
      delete config.uploadedFileData.type;
      delete config.uploadedFileData.configName;

      return updatedFile;
    }
    else {
      return null;
    }
  }

  private setFormValidatorsByProcessingClass(name: string) {
    if (this.providerIsMedical()) {
      this.practiceNumberFormControl.setValidators([Validators.required]);
      this.practiceNumberFormControl.updateValueAndValidity();
    }
    else {
      this.practiceNumberFormControl.clearAsyncValidators();
      this.practiceNumberFormControl.setValidators(null);
      this.practiceNumberFormControl.updateValueAndValidity();
    }
  }

  private deleteLocalFileState() {
    this.clearScanCopyFileUpload();
    this.openSnackBar(`File deleted successfully!`, 'Dismiss');
  }

  private clearScanCopyFileUpload() {
    this.scanCopyFileUploadConfig.uploadedFileData = null;
  }

  private setScanCopyFileUpload(file: any) {
    this.scanCopyFileUploadConfig.uploadedFileData = file;
  }

  private deleteFile$(fileId: bigint): Observable<any> {
    return new Observable(observer => {
      this.fileUploadService.deleteFile(fileId)
        .pipe(
          take(1),
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          () => {
            observer.next({
              success: true
            });
          },
          (error) => {
            observer.next({
              success: false,
              error
            });
          }
        );
    });
  }

  private disableActivityPage() {
    this.contractFormGroup.disable();
    this.contractBackButton.disabled = true;
    this.contractClearButton.disabled = true;
    this.finishButton.disabled = true;
    this.generalStep.editable = false;
    this.addressStep.editable = false;
    this.contactsStep.editable = false;
    this.statutoryStep.editable = false;
    this.contractStep.editable = false;
    if (this.specialitiesStep) {
      this.specialitiesStep.editable = false;
    }
  }

  private enableActivityPage() {
    this.contractFormGroup.enable();
    this.contractBackButton.disabled = false;
    this.contractClearButton.disabled = false;
    this.finishButton.disabled = false;
    this.generalStep.editable = true;
    this.addressStep.editable = true;
    this.contactsStep.editable = true;
    this.statutoryStep.editable = true;
    this.contractStep.editable = true;
    if (this.specialitiesStep) {
      this.specialitiesStep.editable = true;
    }
  }

  private getProviderGroupDTOPayload() {
    const entityStatus = this.entityStatus.find(item => item.name === this.entityStatusFormControl.value);
    const businessType = this.businessType.find(item => item.name === this.businessTypeFormControl.value);
    const processingClass = this.processingClasses.find(item => item.name === this.processingClassFormControl.value);
    const regulator = this.regulator.find(item => item.name === this.regulatorFormControl.value);

    if (this.businessLicenseScannedCopy) {
      const arr = this.businessLicenseScannedCopy.split('base64,');
      this.businessLicenseScannedCopy = arr.length ? arr[1] : this.businessLicenseScannedCopy;
    }

    // Note: Remove file byte[] data before payload at BE
    // we can't use clear `clearFileData` since` we are creating list on FE side,

    this.removeFileByteDataSelectedContracts();

    // Get addresses from shared component
    const addressPayload = this.addressFormComponent.getPayload();

    // Get contacts from shared component
    const contactPayload = this.contactFormComponent.getPayload();

    const payload: ProviderGroupDTO = {
      name: this.providerNameFormControl.value,
      practiceNumber: this.practiceNumberFormControl.value !== '' ? this.practiceNumberFormControl.value : null,
      startDate: new Date(this.startDateFormControl.value),
      endDate: this.endDateFormControl.value !== null
      && this.endDateFormControl.value !== ''
        ? new Date(this.endDateFormControl.value) : null,
      businessLicenseNumber: this.businessLicenseNumberFormControl.value,
      businessLicenseExpiryDate: new Date(this.businessLicenseExpiryFormControl.value),
      businessLicenseScannedCopy: null, // TODO fix in GU-512 this.businessLicenseScannedCopy,
      vatNumber: this.vatNumberFormControl.value,
      vatOverride: this.vatApplicable === 'Yes',
      gstNumber: this.gstNumber.value,
      gstOverride: this.gstApplicable === 'Yes',
      sanctionCheckDate: null,
      sanctionReference: this.sanctionCheckReferenceNumber.value,
      sanctionIndicator: true,
      bankAccount: this.selectedProviderGroup ? this.selectedProviderGroup.bankAccount : null,
      regulator,
      businessType,
      entityStatus,
      processingClass,
      country: addressPayload.addresses[0].address.country,
      addresses: addressPayload.addresses,
      contacts: contactPayload.contacts,
      contracts: this.selectedContracts,
      created: new Date(),
      createdBy: this.userFirstLastName,
      providerGroupId: this.providerId ? Number(this.providerId) : null,
      tenantId: null,
      updated: this.providerId ? new Date() : null,
      updatedBy: this.providerId ? this.userFirstLastName : null,
    };
    return payload;
  }

  private getProviderDTOPayload() {
    const entityStatus = this.entityStatus.find(item => item.name === this.entityStatusFormControl.value);
    const businessType = this.businessType.find(item => item.name === this.businessTypeFormControl.value);
    const providerFacilityType = this.facilityTypes.find(item => item.name === this.providerFacilityTypeFormControl.value);
    const processingClass = this.processingClasses.find(item => item.name === this.processingClassFormControl.value);
    const regulator = this.regulator.find(item => item.name === this.regulatorFormControl.value);

    if (this.partOfGroup === 'Yes') {
      const isUpdated = this.hasProviderGroupBeenUpdated();
      this.providerGroupHistory = isUpdated ? this.providerGroupHistory : this.providerGroupHistory.slice(1);

      const providerGroupLinkObj: any = {
        created: isUpdated ? this.initialProviderGroup.created : new Date(),
        createdBy: isUpdated ? this.initialProviderGroup.createdBy : this.userFirstLastName,
        payToGroup: this.payGroup === 'Yes' ? 1 : 0,
        providerGroupDTO: this.selectedProviderGroup,
        tenantId: null,
        updated: new Date(),
        updatedBy: this.userFirstLastName,
        useGroupPriceList: this.useGroupPriceList === 'Yes' ? 1 : 0,
        startDate: new Date(this.startDateGroupFormControl.value),
        endDate: this.endDateGroupFormControl.value && this.endDateGroupFormControl.value !== ''
          ? new Date(this.endDateGroupFormControl.value) : null
      };

      this.providerGroupHistory.push(providerGroupLinkObj);
    }

    if (this.businessLicenseScannedCopy) {
      const arr = this.businessLicenseScannedCopy.split('base64,');
      this.businessLicenseScannedCopy = arr.length ? arr[1] : this.businessLicenseScannedCopy;
    }

    // Note: Remove file byte[] data before payload at BE
    // we can't use clear `clearFileData` since` we are creating list on FE side,

    this.removeFileByteDataSelectedContracts();

    // Get addresses from shared component
    const addressPayload = this.addressFormComponent.getPayload();

    // Get contacts from shared component
    const contactPayload = this.contactFormComponent.getPayload();

    const payload: ProviderDTO = {
      name: this.providerNameFormControl.value,
      practiceNumber: this.practiceNumberFormControl.value !== '' ? this.practiceNumberFormControl.value : null,
      providerOrder: this.providerOrderFormControl.value,
      startDate: new Date(this.startDateFormControl.value),
      endDate: this.endDateFormControl.value
      && this.endDateFormControl.value !== ''
        ? new Date(this.endDateFormControl.value) : null,
      businessLicenseNumber: this.businessLicenseNumberFormControl.value,
      businessLicenseExpiryDate: new Date(this.businessLicenseExpiryFormControl.value),
      businessLicenseScannedCopy: null, // TODO fix in GU-512 this.businessLicenseScannedCopy,
      vatNumber: this.vatNumberFormControl.value,
      vatOverride: this.vatApplicable === 'Yes',
      gstNumber: this.gstNumber.value,
      gstOverride: this.gstApplicable === 'Yes',
      sanctionCheckDate: null,
      sanctionReference: this.sanctionCheckReferenceNumber.value,
      sanctionIndicator: true,
      note: {
        name: this.addNoteFormControl.value,
        value: this.isEditMode ? this.note?.value ?? null : null,
      },
      regulator,
      businessType,
      providerFacilityType,
      entityStatus,
      processingClass,
      bankAccount: this.selectedProvider ? this.selectedProvider.bankAccount : null,
      country: addressPayload.addresses[0].address.country,
      addresses: addressPayload.addresses,
      contacts: contactPayload.contacts,
      contracts: this.selectedContracts,
      providerGroups: this.providerGroupHistory,
      providerSpecialties: this.getListOfSpecialitiesPayload(),
      billingId: null,
      created: new Date(),
      createdBy: this.userFirstLastName,
      groupSettlement: null,
      providerId: this.providerId ? Number(this.providerId) : null,
      tenantId: null,
      updated: this.providerId ? new Date() : null,
      updatedBy: this.providerId ? this.userFirstLastName : null,
      providerNetworkList: this.providerNetworkList
    };

    return payload;
  }

  private getListOfSpecialitiesPayload(): ProviderSpecialtyLinkDTO[] {
    return this.selectionControl.selected.map(speciality => {
      const providerSpecialityLinkDto = new ProviderSpecialtyLinkDTO();
      providerSpecialityLinkDto.providerSpecialtyDTO = speciality;
      return providerSpecialityLinkDto;
    });
  }

  private removeFileByteDataSelectedContracts() {

    if (this.selectedContracts && this.selectedContracts.length > 0) {
      this.selectedContracts.forEach((item: ProviderContractLinkDTO) => {
        if (item.contract.scanCopyFile && item.contract.scanCopyFile.file) {
          item.contract.scanCopyFile.file = null;
        }
      });
    }
  }
}
